import React from 'react'
import Loading from './Loading'

const LoadingImage = ({url, alt, height=200, width=200}) => {
    const imgRef = React.useRef()
    const [isLoading, setLoading] = React.useState(false)

    React.useEffect(()=>{
        if(imgRef.current && imgRef.current.onLoadStart){
            setLoading(true)
        }
    },[])

    return (
        <>
        {isLoading ? <Loading /> :
         <img src={url} alt={alt} height={height} width={width}  ref={imgRef}  onLoad={()=> setLoading(false)} />}
        </>
    )
}

export default LoadingImage
